import React from "react"
import PropTypes from "prop-types"

import {
  FineResultsContainer,
  FineResultsContainerTitle,
  FineResultsList,
  FineResultsItem,
  FineResultsItemName,
  FinaResultsItemResponse,
} from "./style"

const FineResults = props => {
  console.log(props)
  return (
    <FineResultsContainer>
      <FineResultsContainerTitle>CURRENT FINE:</FineResultsContainerTitle>
      <FineResultsList>
        <FineResultsItem>
          <FineResultsItemName>Fine:</FineResultsItemName>
          <FinaResultsItemResponse>{props.Fine}</FinaResultsItemResponse>
        </FineResultsItem>
        <FineResultsItem>
          <FineResultsItemName>Status:</FineResultsItemName>
          <FinaResultsItemResponse>{props.Status}</FinaResultsItemResponse>
        </FineResultsItem>
        <FineResultsItem>
          <FineResultsItemName>Amount:</FineResultsItemName>
          <FinaResultsItemResponse>{props.Amount}</FinaResultsItemResponse>
        </FineResultsItem>
        <FineResultsItem>
          <FineResultsItemName>Due:</FineResultsItemName>
          <FinaResultsItemResponse>{props.Due}</FinaResultsItemResponse>
        </FineResultsItem>
        <FineResultsItem>
          <FineResultsItemName>Note:</FineResultsItemName>
          <FinaResultsItemResponse>{props.Note}</FinaResultsItemResponse>
        </FineResultsItem>
        <FineResultsItem>
          <FineResultsItemName>About you:</FineResultsItemName>
          <FinaResultsItemResponse>{props.About}</FinaResultsItemResponse>
        </FineResultsItem>
      </FineResultsList>
    </FineResultsContainer>
  )
}

export default FineResults

FineResults.defaultProps = {
  Fine: "Toll road fine",
  Status: "Ticket",
  Amount: "I don’t know ",
  Due: "It’s overdue / due now",
  Note: " The fine was unfairly issued",
  About: "Over 18, $850+ per week",
}

FineResults.propTypes = {
  data: PropTypes.array,
  mainTitle: PropTypes.string,
  option01: PropTypes.object,
  option02: PropTypes.object,
  option03: PropTypes.object,
  option04: PropTypes.object,
  titles: PropTypes.array,
  excerpt: PropTypes.array,
  important: PropTypes.array,
}
